<template>
  <div class="file-download">
    <v-btn
      color="primary"
      class="normal-case"
      flat
      @click="downloadFile"
    >
      Download {{ file.name || "file" }} (.{{getFileExtention()}})
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "FileDownload",
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  methods: {
    getFileExtention() {
            let temp = this.file.file_name.split(".")

            return temp[temp.length - 1]
        },
    downloadFile() {
      const link = document.createElement("a");
      link.href = this.file.file_64;
      link.download = this.file.name || "download";
      link.click();
    }
  }
};
</script>

<style scoped>
.file-download {
  display: flex;
  align-items: center;
}

.normal-case {
  text-transform: none !important;
}
</style>